import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const SkeletonTicketCard = () => {
  return (
    <div style={{
      width: '250px',
      borderRadius: '12px',
      overflow: 'hidden',
      backgroundColor: '#fff',
      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
      paddingBottom: '1rem',
      textAlign: 'center'
    }}>
      {/* Image skeleton */}
      <Skeleton height={150} />

      {/* Text content */}
      <div style={{ padding: '1rem' }}>
        <p><Skeleton width={120} height={14} /></p> {/* Next super Prize */}
        <p><Skeleton width={220} height={24} /></p> {/* Prize Amount */}
        <p><Skeleton width={160} height={18} /></p> {/* Brand Name */}
        
        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '0.5rem' }}>
          <Skeleton width={80} height={14} /> {/* Draw */}
          <Skeleton width={80} height={14} /> {/* Date */}
        </div>

        {/* Buttons */}
        <div style={{ marginTop: '1rem' }}>
          <Skeleton width={200} height={36} style={{ borderRadius: '20px' }} />
        </div>
        <div style={{ marginTop: '0.5rem' }}>
          <Skeleton width={200} height={36} style={{ borderRadius: '20px' }} />
        </div>
      </div>
    </div>
  );
};

export default SkeletonTicketCard;
